import axios from "axios"
import uuid from "uuid/v4"
import getEnv from "../../helpers/common/getEnv"
import {getAccessToken, logout} from "../AuthServices"
import addQueryToUrl from "../../helpers/routes/addQueryToUrl"
import {getAppVersion} from "../AppServices"

class APIServices {
    constructor(baseURL) {
        this._baseURL = baseURL || getEnv('baseAPI')

        this.api = axios.create({
            baseURL: this._baseURL,
            timeout: 30000,
        })
    }

    makeRequest(args) {
        const _headers = args.headers ? args.headers : {}

        const defaultHeaders = {
            'X-App-Version': getAppVersion(),
        }

        args = {
            ...args,
            headers: {
                ...defaultHeaders,
                ..._headers
            }
        }

        return this.api(args)
            .then(response => {
                return Promise.resolve(response.data)
            })
    }

    makeAuthRequest(args, noCache = false) {
        const requestHeaders = args.headers ? args.headers : {}

        let headers = {
            'Authorization': getAccessToken()
        }

        if (noCache) {
            //Add query no-cache to change url request
            const url = args.url || ''
            args = {
                ...args,
                url: addQueryToUrl(url, {'no-cache': uuid()})
            }

            // Add header no-cache
            headers = {
                ...headers,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        }

        args = {
            ...args,
            headers: {
                ...headers,
                ...requestHeaders
            }
        }

        const request = this.makeRequest(args)

        return this._catchError(request)
    }

    _catchError = request => {
        return request.catch(error => {
            const {request} = error

            if (request && request.status && request.status === 403) {
                logout()
            }

            throw error
        })
    }
}

export const extendsAPIServices = (baseURL) => {
    return new APIServices(baseURL)
}

export default new APIServices()



// WEBPACK FOOTER //
// ./src/services/apis/APIServices.js